import { render, staticRenderFns } from "./Vgudang.vue?vue&type=template&id=345fb488"
import script from "./Vgudang.vue?vue&type=script&lang=js"
export * from "./Vgudang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports